import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Header from "./Header";
import Verticalsidebar from "./verticalsidebar";
import Spinner from "../DefaultComponent/Spinner";
import { url } from "../../Config/Config";

function Layout() {
  const { login_status, session_loading } = useSelector(
    (state: any) => state.UserLoginDataState
  );

  if (session_loading) {
    return <Spinner />;
  }

  if (login_status !== true) {
    return <Navigate to={url + "/login"} replace />;
  }

  return (
    <div
      id="main-wrapper"
      data-theme="light"
      data-layout="vertical"
      data-navbarbg="skin6"
      data-sidebartype="mini-sidebar"
      data-sidebar-position="fixed"
      data-header-position="fixed"
      data-boxed-layout="boxed"
    >
      <Header />
      <Verticalsidebar />
      <Outlet />
    </div>
  );
}

export default Layout;
